<template>
  <klaviyo />
</template>

<script>

/**
 * Vue: Analytics Index (analytics)
 * -----------------------------------------------------------------------------
 * Entry point for analytics
 *
 */

import Klaviyo from '~global/analytics/klaviyo'

export default {

  name: 'AnalyticsIndex',

  components: {
    Klaviyo,
  },
}
</script>
